export default __webpack_public_path__ + "static/media/circle.aeb8a724.svg";